import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { AlertComponent } from '../core/alert/alert.component';
import { Alert, AskingAlert } from '../models/alert';
import { AlertResult } from '../models/api-response.interface';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(protected dialog: MatDialog) {}

  private openAlertDialog<T>(
    type: string,
    data: Alert | AskingAlert,
    width = '380px',
    cancelAble = false
  ): Promise<T> {
    return new Promise((resolve) => {
      const dialogRef = this.dialog.open(AlertComponent, {
        width,
        data: {
          type,
          imagePath: this.getImagePath(type),
          data,
        },
        disableClose: cancelAble,
      });

      dialogRef.afterClosed().subscribe((result: T) => {
        resolve(result);
      });
    });
  }

  private getImagePath(type: string): string {
    switch (type) {
      case 'success':
        return '/icons/ic_alert_success.svg';
      case 'error':
        return '/icons/ic_alert_error.svg';
      default:
        return '';
    }
  }

  success(data: Alert): Promise<unknown> {
    return this.openAlertDialog<unknown>('success', data, '380px', data.cancelAble);
  }

  error(data: Alert): Promise<unknown> {
    return this.openAlertDialog<unknown>('error', data, '380px');
  }

  askAlert(data: AskingAlert, width = '500px'): Promise<AlertResult> {
    return this.openAlertDialog<AlertResult>('ask', data, width, true);
  }
}
